import { Activity } from 'farmdok-rest-api';

function calcAmountBasedOnProcessedArea(activity: Activity, activities: Activity[], totalAmount: number): number {
  const totalProcessedArea = activities.reduce((total, act) => total + (act.processedArea ?? 0), 0);
  return ((activity.processedArea ?? 0) / totalProcessedArea) * totalAmount;
}

export default calcAmountBasedOnProcessedArea;
